import React, { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { getNotesData, addData, updateData, deleteIdData } from '../../lib/pagenotes'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

export const GoalsRecommendation = ({ slug, isProfile = false, isStudent = false, plain = false }) => {
	const { user } = useAuth()
	const [data, setData] = useState(null)
	const [showModal, setShowModal] = useState(false)
	const [modalType, setModalType] = useState('add')
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const [formData, setFormData] = useState({
		id: null,
		page: 'StudentAcademicsAssessment',
		studentId: slug,
		instructorId: user?.id,
		instructorNote: ''
	})

	async function GetData() {
		try {
			const allData = await getNotesData(slug, user?.id, 'StudentAcademicsAssessment')
			const filteredData = allData.filter((row) => row.studentId === slug)
			setData(filteredData.length > 0 ? filteredData[0] : null)
		} catch (error) {
			console.error('Error fetching data:', error)
		}
	}

	useEffect(() => {
		if (user?.id) {
			GetData()
		}
	}, [slug, user])

	const toggleModal = () => setShowModal(!showModal)

	const handleOpenModal = (type) => {
		if (type === 'edit' && data?.id) {
			setModalType('edit')
			setFormData({
				id: data.id,
				page: 'StudentAcademicsAssessment',
				studentId: slug,
				instructorId: user?.id,
				instructorNote: data.instructorNote || ''
			})
		} else {
			setModalType('add')
			setFormData({
				page: 'StudentAcademicsAssessment',
				studentId: slug,
				instructorId: user?.id,
				instructorNote: ''
			})
		}
		setShowModal(true)
	}

	const handleChange = (e) => {
		const { name, value } = e.target
		setFormData((prev) => ({ ...prev, [name]: value }))
	}

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSave = async () => {
		try {
			if (modalType === 'edit') {
				await updateData(formData)
			} else {
				await addData(formData)
			}
			await GetData()
			
			showToastMessage(modalType === 'edit' ? 'Recommendation updated successfully!' : 'Recommendation added successfully!')
			toggleModal()
		} catch (error) {
			console.error('Error saving data:', error)
		}
	}

	const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			try {
				await deleteIdData(id)
				await GetData()
				
				showToastMessage('Recommendation deleted successfully!')
				toggleModal()
			} catch (error) {
				console.error('Error deleting data:', error)
			}
		}
	}

	const renderContent = () => (
		<>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			{!isProfile && !isStudent && (
				<div className="d-flex justify-content-end mb-3">
					<button className="btn btn-primary btn-sm" onClick={() => handleOpenModal(data?.id ? 'edit' : 'add')}>
						<i className="fa fa-plus me-2"></i>
						{data?.id ? 'Edit Recommendation' : 'Add Recommendation'}
					</button>
				</div>
			)}
			<div>
				<p className="mb-2">
					<strong>Goals/Recommendation:</strong>
				</p>
				{data && data?.id ? (
					<p className="mb-0">{data?.instructorNote || 'No recommendation available.'}</p>
				) : (
					<p className="mb-0">No recommendation available.</p>
				)}
			</div>

			<Modal isOpen={showModal} toggle={toggleModal}>
				<ModalHeader toggle={toggleModal}>{modalType === 'edit' ? 'Update Recommendation' : 'Add Recommendation'}</ModalHeader>
				<ModalBody>
					<Form>
						<FormGroup>
							<Label for="instructorNote">Recommendation</Label>
							<Input
								type="textarea"
								name="instructorNote"
								id="instructorNote"
								rows={4}
								value={formData.instructorNote || ''}
								onChange={handleChange}
							/>
						</FormGroup>
					</Form>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleModal}>
						Close
					</Button>
					<Button color="primary" onClick={handleSave}>
						{data && data?.id ? 'Update' : 'Save'}
					</Button>
					{modalType === 'edit' && (
						<Button color="danger" onClick={() => handleDelete(formData.id)}>
							Delete
						</Button>
					)}
				</ModalFooter>
			</Modal>
		</>
	)

	if (plain) {
		return renderContent()
	}

	return (
		<div>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="card shadow-sm mb-4" style={{ borderRadius: '8px' }}>
				<div className="card-header border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{!isProfile && (
							<button
								type="button"
								className="btn btn-link p-0 me-2"
								data-bs-toggle="collapse"
								data-bs-target="#collapseGoals"
								aria-expanded="false"
								aria-controls="collapseGoals"
							>
								<i className="fa fa-chevron-down"></i>
							</button>
						)}
						<h5 className="mb-0 d-inline-block">GOALS</h5>
					</div>
				</div>
				<div className={isProfile ? '' : 'collapse'} id="collapseGoals">
					<div className="card-body">
						{renderContent()}
					</div>
				</div>
			</div>
		</div>
	)
}
